export interface DetectionBox {
  x: number;
  y: number;
  w: number;
  h: number;
  score: number;
  classId?: number;
}

export interface SideAlignment {
  top: boolean;
  right: boolean;
  bottom: boolean;
  left: boolean;
}

export interface ClassificationResult {
  class: string;
  confidence: number;
  classIndex: number;
}


export interface IDetectionService {
  loadModel(): Promise<void>;
  loadClassificationModel(): Promise<void>;
  isModelLoaded(): boolean;
  preprocess(video: HTMLVideoElement): any;
  runInference(inputTensor: any): Promise<DetectionBox[]>;
  classifyDocument(canvas: HTMLCanvasElement): Promise<ClassificationResult | null>;
  checkSideAlignment(box: DetectionBox, maskConfig: any): SideAlignment;
  isCardInFrame(box: DetectionBox): boolean;
  areAllSidesAligned(alignment: SideAlignment): boolean;
  cleanup(): void;
}